import { TweenMax as TM, ScrollToPlugin } from 'gsap/all'

const treeShakingAvoided = [ScrollToPlugin]




/* UTILITIES
---------------------------------------------------------------------------------------------------- */

export const sample = arr => arr[Math.floor(Math.random() * arr.length)]


export const random = (min, max) => Math.floor(Math.random() * (max - min)) + min


export const sum = values => values.reduce((currSum, value) => currSum + value, 0)


export const mean = values => sum(values) / values.length


export const clamp = (val, min = 0, max = 1) => Math.max(min, Math.min(max, val))


export const roundTo = (number, places = 0) => Math.round(number * 10 ** places) / 10 ** places


export const debounce = (callback, wait, timeoutId = null) => (...args) => {
    window.clearTimeout(timeoutId)

    timeoutId = setTimeout(() => {
        callback.apply(null, args);
    }, wait)
}


export const randomN = (arr, n) => (
    arr.map(x => ({ x, r: Math.random() }))
        .sort((a, b) => a.r - b.r)
        .map(a => a.x)
        .slice(0, n)
)


export const isEmpty = obj => Object.keys(obj).length === 0


export const omit = (obj, key) => {
    const newObj = {}

    for (var name in obj) {
        if (name !== key) {
            newObj[name] = obj[name]
        }
    }

    return newObj
}


// Either removes or adds an item to an array
// EXAMPLE: toggleInArray([1, 2], 3) -> [1, 2, 3]
// EXAMPLE: toggleInArray([1, 2], 2) -> [1]
export const toggleInArray = (arr, item) => (
    arr.includes(item) ? arr.filter(i => i !== item) : [...arr, item]
)

// Combines 2 arrays, removing duplicates.
// EXAMPLE: mergeUnique([1, 2], [2, 3]) -> [1, 2, 3]
export const mergeUnique = (arr1, arr2) => (
    arr1.concat(arr2.filter(item => arr1.indexOf(item) === -1))
)


export const deleteCookie = (key) => {
    document.cookie = `${encodeURIComponent(key)}=; expires=Thu, 01 Jan 1970 00:00:00 GMT`
}


export const convertHexToRGBA = (hex, alpha = 1) => {
    const r = parseInt(hex.slice(1, 3), 16)
    const g = parseInt(hex.slice(3, 5), 16)
    const b = parseInt(hex.slice(5, 7), 16)

    return `rgba(${r}, ${g}, ${b}, ${alpha})`
}


export const wrap = (el, wrapper) => {
    el.parentNode.insertBefore(wrapper, el)
    wrapper.appendChild(el)
}


export const unwrap = (content) => {
    for (let i = 0; i < content.length; i++) {
        const el     = content[i]
        const parent = el.parentNode

        if (parent.parentNode) parent.outerHTML = el.textContent
    }
}


export const unwrapLine = (line) => {
    for (let i = 0; i < line.length; i++) {
        const el     = line[i]
        const parent = el.parentNode

        while (el.firstChild) parent.insertBefore(el.firstChild, el)

        parent.removeChild(el)
    }
}


export const getURLParams = (url) => {
    const params = {}

    const parser = document.createElement('a')
    parser.href = url

    const query = parser.search.substring(1)
    const vars = query.split('&')

    for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split('=')

        if (pair[0]) {
            params[pair[0]] = decodeURIComponent(pair[1]).split(',')
        }
    }

    return params
}


export const autoScrollTo = (yVal, dur = 1, cb) => {
    if (APP.Browser.isiOS) {
        const scrollVal = { y: window.pageYOffset }

        TM.to(scrollVal, dur, {
            y          : yVal,
            ease       : Cubic.easeInOut,
            onUpdate   : () => { window.scrollTo(0, scrollVal.y) },
            onComplete : () => { if (cb) cb.call() },
        })
    } else {
        TM.to(window, dur, {
            scrollTo: yVal,
            ease: Cubic.easeInOut,
            onComplete : () => { if (cb) cb.call() },
        })
    }
}

export const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return '0 Bytes'

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return `${parseFloat((bytes / (k ** i)).toFixed(dm))} ${sizes[i]}`
}




/* Asynchronous Fetches
--------------------------------------------------------- */

export const asyncJSON = async url => ((await fetch(url)).json())

export const asyncText = async url => ((await fetch(url)).text())

export const asyncBlob = async url => ((await fetch(url)).blob())




